

















































































































































































































import { Component, Vue } from "vue-property-decorator";
import { Withdraw, Wallet } from "@/interfaces";
import {
  dispatchGetWithdraws,
  dispatchGetWithdrawStates,
  dispatchGetWithdrawRecipetImage
} from "@/store/main/actions";
import {
  readOneWithdraw,
  readWithdrawStateName,
  readImage,
  readHasAdminAccess
} from "@/store/main/getters";
import { readUserOneWallet, readCurrencyName } from "@/store/wallet/getters";
import { readAdminOneUser } from "@/store/admin/getters";
import {
  dispatchGetWallets,
  dispatchGetCurrencies
} from "@/store/wallet/actions";
import { dispatchGetUsers } from "@/store/admin/actions";

@Component
export default class ShowWithdraw extends Vue {
  public valid = true;
  public loading = true;
  public recieptImageUrl = "";

  public withdraw: Withdraw | null = null;
  public wallet: Wallet | null = null;

  public admin = false;

  public TYPE_TRANSFER = 1;
  public TYPE_WITHDRAW = 2;
  public type = this.TYPE_WITHDRAW;

  public async mounted() {
    this.loading = true;
    const promises = [
      dispatchGetWithdraws(this.$store),
      dispatchGetWallets(this.$store),
      dispatchGetWithdrawStates(this.$store),
      dispatchGetCurrencies(this.$store),
      dispatchGetWithdrawRecipetImage(this.$store, {
        withdrawId: +this.$router.currentRoute.params.id
      })
    ];
    if (readHasAdminAccess(this.$store)) this.admin = true;
    if (this.admin) {
      promises.push(dispatchGetUsers(this.$store));
    }
    await Promise.allSettled(promises);
    this.recieptImageUrl = "";
    const withdraw = readOneWithdraw(this.$store)(
      +this.$router.currentRoute.params.id
    );

    console.log(withdraw)

    if (withdraw) this.withdraw = withdraw;
    const wallet_id = this.withdraw?.to_wallet_id;
    if (wallet_id) {
      const wallet = readUserOneWallet(this.$store)(wallet_id);
      if (wallet) this.wallet = wallet;
      this.type = this.TYPE_WITHDRAW;
    }else{
      this.type = this.TYPE_TRANSFER;
    }

    const blob = readImage(this.$store);
    if (blob) {
      const result = await this.readImage(blob);
      if (typeof result === "string") {
        this.recieptImageUrl = result;
      }
    }
    this.loading = false;
  }

  public cancel() {
    this.$router.back();
  }

  public async edit() {
    this.$router.push({
      name: "main-withdraw-edit",
      params: { id: this.$router.currentRoute.params.id }
    });
  }
  public async revert() {
    this.$router.push({
      name: "main-withdraw-revert",
      params: { id: this.$router.currentRoute.params.id }
    });
  }
  public async settle() {
    this.$router.push({
      name: "main-withdraw-settle",
      params: { id: this.$router.currentRoute.params.id }
    });
  }
  public async confirm() {
    this.$router.push({
      name: "main-withdraw-confirm",
      params: { id: this.$router.currentRoute.params.id }
    });
  }

  get from_amount() {
    const amount = this.withdraw?.from_amount;

    if (!this.withdraw?.currency) return "----";

    const currency = readCurrencyName(this.$store)(this.withdraw?.currency);

    if (currency === "IRT") {
      if (amount) return (+amount.toFixed(0)).toLocaleString() + "تومان";
    } else if (currency === "ETH") {
      if (amount) return (amount / 10 ** 18).toFixed(5) + "ETH";
    }else if (currency === "ETC") {
      if (amount) return (amount / 10 ** 18).toFixed(5) + "ETC";
    }else if (currency === "ZIL") {
      if (amount) return (amount / 10 ** 12).toFixed(5) + "ZIL";
    }else if (currency === "XCH") {
      if (amount) return (amount / 10 ** 12).toFixed(5) + "XCH";
    }else if (currency === "XCC") {
      if (amount) return (amount / 10 ** 8).toFixed(5) + "XCC";
    }
    return "----";
  }

  get to_amount() {

    let currency;
    if(this.type == this.TYPE_WITHDRAW){
      if (!this.wallet || !this.wallet?.currency) return "----";
      currency = readCurrencyName(this.$store)(this.wallet?.currency);
    }else {
      if (!this.withdraw?.currency) return "----";
      currency = readCurrencyName(this.$store)(this.withdraw?.currency);
    }

    const amount = this.withdraw?.to_amount;
    if (currency === "IRT") {
      if (amount) return (+amount.toFixed(0)).toLocaleString() + "تومان";
    } else if (currency === "ETH") {
      if (amount) return (amount / 10 ** 18).toFixed(5) + "ETH";
    }else if (currency === "ETC") {
      if (amount) return (amount / 10 ** 18).toFixed(5) + "ETC";
    }else if (currency === "ZIL") {
      if (amount) return (amount / 10 ** 12).toFixed(5) + "ZIL";
    }else if (currency === "XCH") {
      if (amount) return (amount / 10 ** 12).toFixed(5) + "XCH";
    }else if (currency === "XCC") {
      if (amount) return (amount / 10 ** 8).toFixed(5) + "XCC";
    }
    return "----";
  }

  get wallet_string() {
    const wallet_id = readOneWithdraw(this.$store)(
      +this.$router.currentRoute.params.id
    )?.to_wallet_id;
    if (!wallet_id) return "----";
    const wallet = readUserOneWallet(this.$store)(wallet_id);
    if (!wallet) return "----";
    return `${wallet.id}/${wallet.owner_id}/${wallet.name}/${wallet.currency}/${wallet.address}`;
  }
  get user() {
    const user_id = readOneWithdraw(this.$store)(
      +this.$router.currentRoute.params.id
    )?.from_user_id;
    if (user_id) return readAdminOneUser(this.$store)(user_id);
    return null;
  }
  get user_string() {
    // const user_id = readOneWithdraw(this.$store)(
    //   +this.$router.currentRoute.params.id
    // )?.from_user_id;
    // if (!user_id) return "----";
    // const user = readAdminOneUser(this.$store)(user_id);
    if (!this.user) return "----";
    return `${this.user.id}/${this.user.full_name}/${this.user.mobile}/${this.user.balance}`;
  }
  get currency() {
    const wallet_id = readOneWithdraw(this.$store)(
      +this.$router.currentRoute.params.id
    )?.to_wallet_id;
    if (!wallet_id) return "----";
    const wallet = readUserOneWallet(this.$store)(wallet_id);
    if (!wallet || !this.withdraw?.currency) return "----";
    return `${readCurrencyName(this.$store)(this.withdraw?.currency)}
            ->
            ${readCurrencyName(this.$store)(wallet?.currency)}`;
  }
  get state() {
    const state_id = readOneWithdraw(this.$store)(
      +this.$router.currentRoute.params.id
    )?.state;
    if (!state_id) return "----";
    return readWithdrawStateName(this.$store)(state_id);
  }

  public getColor() {
    if (this.state === "COMPLETED" || this.state === "MANUAL_SETTLEMENT")
      return "color:green";
    else if (this.state === "REJECTED" || this.state === "FAILED")
      return "color:red";
    return "color:blue";
  }

  public readImage(image_blob: Blob) {
    return new Promise<string | ArrayBuffer | null>(resolve => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(image_blob);
    });
  }

  public async showReciept() {
    if (!this.withdraw?.reciept) return;
    if (this.withdraw?.reciept.startsWith("0x")) {
      const link = "https://etherscan.io/tx/" + this.withdraw?.reciept;
      window.open(link, "_blank");
    }
  }
}
